
import { FileIcon, Remove } from ".";

import type { File as FileDB } from "easy-db-node";
import { DownloadItem } from "../../types";
import moment from "moment";
import Icon from "@mdi/react";
import { useRef, useState } from "react";
import { mdiFile, mdiPen, mdiPlus } from "@mdi/js";
import Modal from "react-responsive-modal";

export function DownloadList({ downloads }: { downloads: DownloadItem[] }) {
    return <>
        {downloads.length > 0 && <ul className="download-list">
            {downloads.map((d, index) => <li key={index}>
                <a href={d.file.url} target="__blank" download={getFileName(d)}>
                    <FileIcon download={d} />
                    <span className="name">{d.name}</span>
                    <span className="date">{moment(d.date).format("LL")}</span>
                </a>
            </li>)}
        </ul>}
    </>;
}

export function DownloadAdmin({ downloads, onChange }: { downloads: DownloadItem[], onChange: (downloads: DownloadItem[]) => Promise<boolean> }) {

    const [message, setMessage] = useState("");
    const inputDownloadRef = useRef<HTMLInputElement>(null);

    const [editDownload, setEditDownload] = useState<null | DownloadItem & { index: number }>(null);

    async function handleSaveDownload() {
        if (!editDownload) return;

        const newDownloads: DownloadItem[] = [...downloads];

        const { index, ...download } = editDownload;
        newDownloads[index] = download;

        const success = await onChange(newDownloads.sort((a, b) => b.date.localeCompare(a.date)));

        if (!success) {
            setMessage("Ukládání souboru selhalo");
            return;
        }
        setMessage("Soubor byl úspěšně uložen");
        setEditDownload(null);
    }

    async function handleRemoveDownload(index: number) {
        const success = await onChange(downloads.filter((_, i) => i !== index));

        if (!success) {
            setMessage("Mazání souboru selhalo");
            return;
        }
        setMessage("Soubor byl úspěšně smazán");
    }

    return <>
        <div style={{ position: "relative", height: 100 }}>
            <div className="admin">
                <button onClick={() => inputDownloadRef.current?.click()}>
                    <Icon path={mdiPlus} size={1} />Přidat soubor
                </button>
                <input
                    className="hidden"
                    ref={inputDownloadRef}
                    type="file"
                    placeholder="Nahrát soubor"
                    onChange={async (e) => {
                        const file = e.target.files?.[0] as File;
                        if (!file) return;

                        const url = await toBase64(file);

                        setMessage("");
                        setEditDownload({
                            index: editDownload?.index || downloads?.length || 0,
                            date: editDownload?.date || moment().format("YYYY-MM-DD"),
                            name: file.name,
                            file: {
                                type: "EASY_DB_FILE",
                                url,
                            },
                        });
                    }}
                />
            </div>
        </div>
        <div>
            {downloads.length > 0 && <ul className="download-list">
                {downloads.map((d, index) => <li key={index}>
                    <a href={d.file.url} target="__blank" download={getFileName(d)}>
                        <FileIcon download={d} />
                        <span className="name">{d.name}</span>
                        <span className="date">{moment(d.date).format("LL")}</span>
                    </a>
                    <div className="control">
                        <button className="icon" onClick={() => setEditDownload({ ...d, index })}>
                            <Icon path={mdiPen} size={1} />
                        </button>
                        <Remove onRemove={() => handleRemoveDownload(index)} />
                    </div>
                </li>)}
            </ul>}
            <Modal
                open={editDownload !== null}
                onClose={() => setEditDownload(null)}
                center
                styles={{ modal: { width: "500px" } }}
            >
                {message && <p className="alert">{message}</p>}
                {editDownload && <>
                    <h2>Soubor k projektu</h2>
                    <button onClick={() => inputDownloadRef.current?.click()}>
                        <Icon path={mdiFile} size={1} />Nahrát jiný soubor
                    </button>
                    <p>Soubor může mít maximálně 10MB!</p>
                    <input
                        type="date"
                        placeholder="Datum vystavení"
                        value={editDownload.date}
                        onChange={(e) => setEditDownload({ ...editDownload, date: moment(e.target.value).format("YYYY-MM-DD") })}
                    />
                    <input
                        type="text"
                        placeholder="Název"
                        value={editDownload.name}
                        onChange={(e) =>
                            setEditDownload({ ...editDownload, name: e.target.value })}
                    />
                    <button onClick={handleSaveDownload}>Uložit soubor</button>
                </>}
            </Modal>
        </div>
    </>;
}


export function getFileName(download: { name: string, file: FileDB }): string {
    const url = download.file.url.split(".");
    const ext = url[url.length - 1];

    if (download.name.endsWith(`.${ext}`)) return download.name;

    return `${download.name}.${ext}`;
}

export async function toBase64(file: File): Promise<string> {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result?.toString() || "");
        reader.onerror = reject;
    });
}